const portfolio_data = {
 //Introduction section data
  introduction: `Hey there! I'm Vaibhav Gangrade, a software developer, and I'm excited to show you what I've been up to in the world of coding. This is like my digital scrapbook where you can see the cool projects I've worked on. From making websites look awesome to building behind-the-scenes systems, I love turning ideas into real, working software. I'm not just a coder; I'm always learning new things to stay on top of the latest tech trends. Think of me as a tech explorer, always looking for better and cooler ways to make things work. So, come along and explore with me! We'll dive into the world of coding and create some awesome stuff together. Thanks for stopping by, and let's have some fun with code! Cheers.`,
    
    MyImage:'/images/vaibhav_gangrade.jpg',

//Skills data

  skillsData: [

    { label: "HTML", value: 95, circleColor: "#E34F26", waveColor: "#E34F26" },
    { label: "CSS", value: 90, circleColor: "#1572B6", waveColor: "#1572B6" },
    { label: "JS", value: 75, circleColor: "#F7DF1E", waveColor: "#d0b783" },
    { label: "Bootstrap", value: 95, circleColor: "#7952B3", waveColor: "#7952B3" },
    { label: "PHP", value: 85, circleColor: "#777BB4", waveColor: "#777BB4" },
    { label: "Wordpress", value: 95, circleColor: "#21759B", waveColor: "#21759B" },
    { label: "AJAX", value: 75, circleColor: "#F16529", waveColor: "#F16529" },
    { label: "MVC.Net", value: 75, circleColor: "#68217A", waveColor: "#68217A" },
    { label: "Angular", value: 40, circleColor: "#DD0031", waveColor: "#DD0031" },
    { label: "React", value: 50, circleColor: "#61DAFB", waveColor: "#61DAFB" },
    { label: "Node", value: 50, circleColor: "#339933", waveColor: "#339933" },
    { label: "Laravel", value: 55, circleColor: "#FF2D20", waveColor: "#FF2D20" },
    { label: "CI", value: 60, circleColor: "#EF6636", waveColor: "#EF6636" },
    { label: "SEO", value: 75, circleColor: "#0E76A8", waveColor: "#0E76A8" },
    { label: "WP Plugins", value: 90, circleColor: "#4AB29A", waveColor: "#4AB29A" },
    { label: "Debugging", value: 80, circleColor: "#6B8E23", waveColor: "#6B8E23" },

  ],

/**WORK EXPERIENCE SECTION STARTS HERE*/
	//right-2 or //left-2
  workExperienceData:[
	  {
  		companyImg:"/images/cis.jpg",
		  companyname:"CIS ( Cyber Infrastructure )",
  		desigNation:"Software Developer",
		  cardAlignmentClass:"right-2",
  		WorkDuration:"FEB 2021-Now",
  		WorkDescription:`Working as a software developer and responsible for the followoing process in the project like:
  		1)Project Understanding
		2)Project Devlopment
		3)Bugs Fixing and enchancement
  		4)Client Reporting via different reporting tools and skype`,
  		companyLink:"https://www.cisin.com/"
  	},
  	{
  		companyImg:"/images/itvedant.png",
		  companyname:"ITVedant Pvt Limited",
		  desigNation:"Web Developer & SEO Analytics",
  		cardAlignmentClass:"left-2",
  		WorkDuration:"June 2020-Dec 2020",
  		WorkDescription:`Worked as a wordpress developer and responsible for the followoing process in the project like:
  		1)Project Understanding
  		2)Project Devlopment
  		3)Bugs resolve and enchancement
      4)Client Reporting via different reporting tools and skype`,

  		companyLink:"https://www.itvedant.com/"
  	},
  	{
  		companyImg:"/images/brillsense.jpg",
		  companyname:"Brillsense Pvt Limited",
		  desigNation:"Web Developer",
  		cardAlignmentClass:"right-2",
  		WorkDuration:"Aug 2019-May 2020",
  		WorkDescription:`Worked as a MVC .Net developer and responsible for the followoing process in the project like:
  		1)Project Understanding
  		2)Project Devlopment
  		3)Bugs resolve and enchancement
  		4)Client Reporting via different reporting tools and skype`,
  		companyLink:"https://www.brillsense.com/"
  	},
  	{
  		companyImg:"/images/eway.jpg",
		  companyname:"e-way It Solutions",
		  desigNation:"Web Developer",
  		cardAlignmentClass:"left-2",
  		WorkDuration:"July 2018-July 2019",
  		WorkDescription:`Worked as a wordpress developer and responsible for the followoing process in the project like:
  		1)Project Understanding
  		2)Project Devlopment
  		3)Bugs resolve and enchancement
  		4)Client Reporting via different reporting tools and skype`,
  		companyLink:"https://ewayitsolutions.com/"
  	},
  	{
  		companyImg:"/images/handk.png",
		  companyname:"H&K Technosoft",
		  desigNation:"Jr Developer",
  		cardAlignmentClass:"right-2",
  		WorkDuration:"Aug 2017-May 2018",
  		WorkDescription:`Worked as a wordpress developer and responsible for the followoing process in the project like:
  		1)Project Understanding
  		2)Project Devlopment
  		3)Bugs resolve and enchancement
  		4)Client Reporting via different reporting tools and skype`,
  		companyLink:"#"
  	}
  ],

  /**WORK EXPERIENCE SECTION ENDS HERE*/

/*Hobbies section starts here*/

/*Hobbies section ends here */

/*Education section starts here*/

/*Education section ends here */


/*Achievements section starts here*/
achievements:[
{achievement_description:`<i className="fas fas-trophy"></i> Won <b>First Prize</b> in <b>Chess</b> competetion in college techfest "<b>Emblaze 2K16.</b>"`},
{achievement_description:`Actively Participate in <b>Chess</b> during college sports. `},
{achievement_description:`<i className="fa fa-trophy"></i><b>Secured second position</b> in <b>"general knowledge examination"</b> held in <b>SLS college</b> Shujalpur in the year 2013.</li><li>Two times runner up in chess during college nodals.`},
{achievement_description:`Get apporoval for Wordpress plugin "<b>Custom Admin Login</b>" by <b>Wordpress.org</b> and upload in Plugin directory. `},
{achievement_description:`Get apporoval for Wordpress plugin "<b>Easy FAQ</b>" by <b>Wordpress.org</b> and upload in Plugin directory.`},
{achievement_description:`Get apporoval for Wordpress plugin "<b>Image For Opengraph Meta</b>" by <b>Wordpress.org</b> and upload in Plugin directory.`},
{achievement_description:`Get apporoval for Wordpress plugin "<b>Password Generator Widget</b>" by <b>Wordpress.org</b> and upload in Plugin directory.`},
{achievement_description:`Get apporoval for Wordpress plugin "<b>Dynamic Image Slider</b>" by <b>Wordpress.org</b> and upload in Plugin directory.`},
{achievement_description:`Get apporoval for Wordpress plugin "<b>Element Addon</b>" by <b>Wordpress.org</b> and upload in Plugin directory.`},
],

extraActity:[
  {title:`GITHUB PROJECTS`,numbers:`110`,class:``},
  {title:`PLUGINS IN WORDPRESS DIRECTORY`,numbers:`6`,class:``},
  {title:`PROJECTS HOSTED ON GITHUB`,numbers:`5`,class:``},
],
/*Achievements section ends here */

/*Contact me socail platform section starts here*/

contactMeData:[
{socialPlatFormName:`Facebbok`,socialPlatFormLink:`https://www.facebook.com/vaibhav.gangrade.9`,RefClassNameForLinkHoverColor:`btn btn-primary fb mb-2 socail_btn`},
{socialPlatFormName:`Instagram`,socialPlatFormLink:`https://www.instagram.com/mp_13_lover/`,RefClassNameForLinkHoverColor:`btn btn-primary insta mb-2 socail_btn`},
{socialPlatFormName:`Naukri.com`,socialPlatFormLink:`#`,RefClassNameForLinkHoverColor:`btn btn-primary naukri mb-2 socail_btn`},
{socialPlatFormName:`Skype`,socialPlatFormLink:``,RefClassNameForLinkHoverColor:`btn btn-primary skype mb-2 socail_btn`},
{socialPlatFormName:`Github`,socialPlatFormLink:`https://github.com/Viv31`,RefClassNameForLinkHoverColor:`btn btn-primary github mb-2 socail_btn`},
{socialPlatFormName:`Stackoverflow`,socialPlatFormLink:`https://stackoverflow.com/users/10657696/vaibhav`,RefClassNameForLinkHoverColor:`btn btn-primary stack mb-2 socail_btn`},
{socialPlatFormName:`Email me`,socialPlatFormLink:`mailto:vivgangs@gmail.com`,RefClassNameForLinkHoverColor:`btn btn-primary gmail mb-2 socail_btn`},
{socialPlatFormName:`Linkedin`,socialPlatFormLink:`https://www.linkedin.com/in/vaibhav-gangrade-796387134`,RefClassNameForLinkHoverColor:`btn btn-primary wp mb-2 socail_btn`},
{socialPlatFormName:`WP`,socialPlatFormLink:`https://profiles.wordpress.org/vaibhav31gangrade/`,RefClassNameForLinkHoverColor:`btn btn-primary linkedin mb-2 socail_btn`},
],

ContactPageImg:`/images/contact_me.jpg`,

/*Contact me socail platform section ends here */ 



/*RESUME DOC LINK STARTS HERE*/

resumeLink:`/images/Vaibhav_Gangrade_web_Developer.docx`,

/*RESUME DOC LINK STARTS HERE*/

};

export default portfolio_data;
